import React from 'react'

const defaultState = {
  locale: 'sv',
}

const LanguageContext = React.createContext(defaultState)

type Props = {
  children: any
  locale: string
}

class LanguageProvider extends React.Component<Props> {
  render() {
    const { children, locale } = this.props
    return (
      <LanguageContext.Provider
        value={{
          locale: locale ? locale : 'sv',
        }}
      >
        {children}
      </LanguageContext.Provider>
    )
  }
}

export default LanguageContext
export { LanguageProvider }
